(function ($) {
    /**
     * Function for attaching mobile nav toggling logic on load on smaller screens
     *
     * @return {void} Nothing
     *
     */
    $(document).ready(function ready() {
        try {
            if ($(window).width() <= 992 && is_touch_device()) {
                toggleNav('nav-menu__level', 4);
            } else if ($(window).width() > 992 && is_touch_device()) {
                levelOneLinksAdapt('.nav-menu__level--1');
            }
        } catch (error) {
            console.log(error);
        }
    })

    /**
     * Function for handling mobile nav toggling
     *
     * @param {number} levels - Number of supporting levels
     * @param {string} baseClass - Base level class where the level modifier will be appended
     * @return {void} Nothing
     *
     */
    function toggleNav(baseClass, levels) {
        if (typeof levels !== "number" && typeof baseClass !== "string") {
            throw new Error("Parameters types are incorrect.");
        }

        for (var level = 1; level <= levels; level++) {
            var levelClass = '.' + baseClass + '--' + level;

    
            handleParentClick(levelClass, baseClass, levels);
        }
    }

     /**
     * Function for handling mobile nav event toggling
     *
     * @param {string} levelClass - Level modifier class
     * @param {string} baseClass - Base level class where the level modifier will be appended
     * @param {number} maxLevels - Number of supporting levels
     * @return {void} Nothing
     *
     */
    function handleParentClick(levelClass, baseClass, maxLevels) {
        if (typeof levelClass !== "string") {
            throw new Error("Parameter type is incorrect.");
        }

        var baseLevel = Number(levelClass.substring(levelClass.indexOf('--') + 2));
        var childLevel = baseLevel + 1;
        
        var $levelDropdownToggle = $(levelClass + ' > .has-children > .nav-menu__link');     

        $levelDropdownToggle.click(function (e) {
            var $this = $(this);
            var $levelDropdown = $this.next('.nav-menu__level--' + childLevel);


            if (baseLevel == 1 && !$levelDropdown.hasClass('nav-menu__level--open') && $levelDropdown.length > 0) {
                e.preventDefault();
            }
       
            if (!$levelDropdown.hasClass('nav-menu__level--open') && $levelDropdown.length > 0) {
                e.preventDefault();
                for (var levelToClear = baseLevel; levelToClear <= maxLevels; levelToClear++) {
                    $('.' + baseClass + '--' + levelToClear + ' ' + ' > .has-children > ' + '.nav-menu__level--' + (levelToClear + 1)).removeClass('nav-menu__level--open').slideUp(500);
                }
                $levelDropdown.slideToggle().addClass('nav-menu__level--open');
            }

        });
    }

    /**
     * Function for identifying whether or not user is using a touch-based device
     *
     * @return {bool} Is it a touch-based device
     *
     */
    function is_touch_device() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

        var mq = function (query) {
            return window.matchMedia(query).matches;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    /**
     * Function for preventing level 1 links to instantly navigate to the page on first click
     *
     * @return {void} Nothing
     *
     */
    function levelOneLinksAdapt(baseClass) {
        $(baseClass + ' > .nav-menu__item.has-children > .nav-menu__link').click(function (e) {
            var $this = $(this);

            var $level = $this.closest(baseClass + ' > .nav-menu__item.has-children');

            if (!$level.hasClass('nav-menu__item--open')) {
                e.preventDefault();
                $level.slideDown(500).addClass('nav-menu__item--open');
            }
        });
    }
})(jQuery);